"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { InformationCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import type { FC } from "react";

type Props = {
  color?: string;
};

const InfoIcon: FC<Props> = ({ color = "currentColor" }) => (
  <HugeiconsIcon
    icon={InformationCircleIcon}
    size={12}
    color={color}
    strokeWidth={1.5}
  />
);

export default InfoIcon;
